import * as z from "zod";
import { commerceCloudIntegrationId } from "./list-commerce-cloud-integrations";

const cartProductVariantSchema = z.object({
  id: z.string(),
  sku: z.string().nullish(),
  price: z.number().nullish(),
  inStock: z.boolean().nullish(),
});

export const getCommerceCloudCartProduct = {
  name: "getCommerceCloudCartProduct" as const,
  input: z.object({
    integrationId: commerceCloudIntegrationId,
    /** Defaults to the saved cart product when omitted. */
    productId: z.string().nullish(),
  }),
  output: z.object({
    productId: z.string().nullable(),
    saved: z.boolean(),
    productExists: z.boolean(),
    title: z.string().nullish(),
    variants: z.array(cartProductVariantSchema),
    requiredPrices: z.array(z.number()),
    missingPrices: z.array(z.number()),
    extraPrices: z.array(z.number()),
    pricesMatch: z.boolean(),
    outOfStockCount: z.number(),
    error: z.string().nullish(),
  }),
};

export type CommerceCloudCartProductStatus = z.infer<
  typeof getCommerceCloudCartProduct.output
>;
